export const CHAT_BOT_GENERAL = 'Chat with Daisy' //Daisy Production
export const CHAT_BOT_DAISY_V0 = 'Daisy R&D'//Daisy-RandD
export const CHAT_BOT_WOLF = 'BET Community' //Community BET
export const CHAT_BOT_AA= 'AA Community' //Community AA
export const CHAT_BOT_PARAMOUNT = 'Daisy 0' //Daisy-RandD-DeciderBot
export const CHAT_BOT_NETFLIX = 'Daisy 1' //Daisy - JSON comments
export const CHAT_BOT_DISNEY = 'Daisy 2' //Daisy Demographic Comments
export const CHAT_BOT_PROTOTYPE_3 = 'Wrestling Community' //Community Wrestling
export const CHAT_BOT_PROTOTYPE_2 = 'Beauty Community' //Community Beauty
export const CHAT_BOT_PROTOTYPE_1 = 'Gen Z' //Community Gen Z
export const CHAT_BOT_HISPANIC = 'Hispanic Community' //Community Hispanic

export const CHAT_WITH_DAISY_ASSISTANT_ID = 'DAISY' //'asst_UHQ74MZShpMxFaqouXfT2JGF'
export const DAISY_R_AND_D_ASSISTANT_ID = 'DIESEL_RD' //'asst_y0yhhAsRWcFLF0naWzj6vnL6'
export const BET_ASSISTANT_ID = 'BET' //'asst_j0rWHuo9YcSi7eI482CQsC7X'
export const DAISY_0_ASSISTANT_ID = 'PARAMOUNT' //'asst_DFYD4VQiSJqlodQfSdGxjpuY'
export const DAISY_1_ASSISTANT_ID = 'NETFLIX' //'asst_0uVwKRSiwm1DOpgWinYK6thH'
export const DAISY_2_ASSISTANT_ID = 'DISNEY' //'asst_cOmXn5zjm19EP9HEg2Qw5pIx'
export const DAISY_3_ASSISTANT_ID = 'PROTOTYPE3' //'asst_nGFqIBV6DTEEwn37nuO9jZsh'
export const DAISY_4_ASSISTANT_ID = 'PROTOTYPE2' //'asst_fghXSAQeCrVd6eZsTLwGw0gf'
export const DAISY_5_ASSISTANT_ID = 'PROTOTYPE1' //'asst_D6RbHSn8bz0RysXQVQCO9ftQ'
export const HISPANIC_ASSISTANT_ID = 'HISPANIC' //'asst_SsGbeC7JTPw0n0CqbFYEHyXo'

export const CHAT_BOTS = [
  { botName: 'Chat with Daisy', botValue: CHAT_BOT_GENERAL, assistantId: CHAT_WITH_DAISY_ASSISTANT_ID },
  { botName: 'Daisy R&D', botValue: CHAT_BOT_DAISY_V0, assistantId: DAISY_R_AND_D_ASSISTANT_ID },
  { botName: 'BET Community', botValue: CHAT_BOT_WOLF, assistantId: BET_ASSISTANT_ID },
  { botName: 'AA Community', botValue: CHAT_BOT_AA, assistantId: BET_ASSISTANT_ID },
  { botName: 'Beauty Community', botValue: CHAT_BOT_PROTOTYPE_2, assistantId: DAISY_4_ASSISTANT_ID },
  { botName: 'Wrestling Community', botValue: CHAT_BOT_PROTOTYPE_3, assistantId: DAISY_3_ASSISTANT_ID },
  { botName: 'Hispanic Community', botValue: CHAT_BOT_HISPANIC, assistantId: HISPANIC_ASSISTANT_ID },
  { botName: 'Gen Z', botValue: CHAT_BOT_PROTOTYPE_1, assistantId: DAISY_5_ASSISTANT_ID },
  { botName: 'Daisy 0', botValue: CHAT_BOT_PARAMOUNT, assistantId: DAISY_0_ASSISTANT_ID },
  { botName: 'Daisy 1', botValue: CHAT_BOT_NETFLIX, assistantId: DAISY_1_ASSISTANT_ID },
  { botName: 'Daisy 2', botValue: CHAT_BOT_DISNEY, assistantId: DAISY_2_ASSISTANT_ID }
]